import { useEffect, useState } from "react";
import {
  ChartData,
  ChartDataParams,
  FormatChartData,
} from "../recharts/functions";
import { ReMixChart } from "../recharts/ReMixCharts";
import { titleCase } from "../../extensions/extension";
import LegendSummaryTable, {
  ChartTable,
  downloadChartTableCSV,
  downloadSummaryCSV,
} from "../table/SummaryTable";
import { ExchangeColors } from "../../pages/Rajasthan/Exchange3/FormatData";
import { ChartType } from "../../models/chart_model";
export interface DataPoint{
  // xAxis: str | int | float = Field(..., description="The values for the primary X-axis.")
  // secondXAxis: str | int | float | None = Field(..., description="The values for the secondary X-axis (if applicable).")
  // value: int | float = Field(..., description="The values for the Y-axis.")
  // yAxis_type: str = Field(..., description="Which yAxis the value belongs to left or right.")
  // category: str = Field(..., description="The category of the data point.")
  // chart_type: str = Field(..., description="The type of chart to be plotted bar/line/area etc.")
  // unit: str = Field(..., description="The unit of the data point.")
  xAxis: string | number | null;
  secondXAxis: string | number | null;
  value: number | null;
  yAxis_type: string;
  category: string;
  chart_type: string;
  unit: string;

}
interface AgentChartProps {
  data: DataPoint[];
  chartPar: PlotParameters | null;
}


export interface PlotParameters {
  //   "{
  //     "isTimeSlot": false,
  //     "xAxisKey": "date",
  //     "yAxisKey": "mwh",
  //     "secondXAxisKey": "",
  //     "secondYAxisKey": "price_rs_mwh",
  //     "groupBy": ["line"],
  //     "title": "Demand and IEX DAM wt. avg price for Feb 2025",
  //     "yAxisunit": "MWh",
  //     "secondYAxisunit": "Rs/MWh"
  // }"
  // data: DataPoint[];
  title: string;
  yAxisLabel: string;
  xAxisLabel: string;
  secondXAxisLabel: string | null;
  secondYAxisLabel: string | null;
}

type TabType = {
  label: "Chart" | "Summary" | "Table";
};

const TABS: TabType[] = [
  { label: "Chart" },
  { label: "Summary" },
  { label: "Table" },
];

const markdownStyles = `
  .custom-scrollbar::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  
  .custom-scrollbar::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  .custom-scrollbar::-webkit-scrollbar-thumb {
    background: #34656d;
    border-radius: 4px;
    opacity: 0.7;
  }
  
  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #2a515c;
  }

  @media (max-width: 768px) {
    .gas-chart-container {
      padding: 0.5rem !important;
      height: 350px !important;
    }
    
    .chart-header {
      padding: 0.75rem !important;
    }
    
    .chart-title {
      font-size: 0.875rem !important;
    }
    
    .chart-tabs {
      padding: 0 0.5rem !important;
    }
    
    .chart-tab {
      padding: 0.5rem 0.75rem !important;
      font-size: 0.75rem !important;
    }
    
    .download-button {
      padding: 0.375rem 0.75rem !important;
      font-size: 0.75rem !important;
    }
  }

  @media (max-width: 480px) {
    .gas-chart-container {
      padding: 0.25rem !important;
    }
    
    .chart-header {
      padding: 0.5rem !important;
    }
    
    .chart-title {
      font-size: 0.75rem !important;
    }
    
    .chart-tabs {
      padding: 0 0.25rem !important;
    }
    
    .chart-tab {
      padding: 0.375rem 0.5rem !important;
      font-size: 0.7rem !important;
    }
    
    .download-button {
      padding: 0.25rem 0.5rem !important;
      font-size: 0.7rem !important;
    }
  }
`;

const AgentChart = ({ data, chartPar }: AgentChartProps) => {
  const [chartData, setChartData] = useState<ChartData>({
    keys: [],
    keysLabels: [],
    unit_keys: [],
    group_by: {},
    data: [],
  });
  const [activeTab, setActiveTab] = useState<TabType>(TABS[0]);

  useEffect(() => {
    // Add the styles to the document head
    const styleElement = document.createElement("style");
    styleElement.innerHTML = markdownStyles;
    document.head.appendChild(styleElement);
    console.log({
      data,
      chartPar,
    });
    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  useEffect(() => {
    console.log("Data received to chart");
    const finalData = data.map((item) => ({
      ...item,
      category: item.category + "_",
      unit: item.unit + "_",
      chart_type: item.chart_type + "_",

    }));
    const par: ChartDataParams = {
      data: finalData,
      keys:["xAxis","secondXAxis"],
      tableKeys: ["xAxis","secondXAxis"],
      groupBy: ["category","unit","chart_type","yAxis_type"],
      priceKey: "",
      volumeKey: "value",
      aggregationKeys:[]
    };
    const formattedData = FormatChartData(par);
    setChartData(formattedData);
  }, [data, chartPar]);

  const tablePar = {
    data: chartData.data,
    tableData: chartData.tableData,
    keysLabels: chartData.keysLabels,
    unit: "MWh",
    volumeKey: "value",
    legends: getNonZeroLegends(),

    extraKeys:
      ["xAxis","secondXAxis"],
    extraLabels: [],
  };

  return (
    <div className="w-full bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden">
      <div className="p-4 border-b border-gray-100 bg-gradient-to-r from-[#34656d]/5 to-transparent chart-header">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <svg
              className="w-5 h-5 text-[#34656d]"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M3 3v18h18" />
              <path d="M18.3 8.3L13 13.6l-4-4-6 6" />
            </svg>
            <h3 className="text-sm font-semibold text-[#34656d] chart-title">
              {chartPar?.title || "Data Visualization"}
            </h3>
          </div>
          <button
            onClick={() => {
              activeTab.label === "Chart" && downloadChartTableCSV(tablePar);
              activeTab.label === "Summary" && downloadSummaryCSV(tablePar);
              activeTab.label === "Table" && downloadChartTableCSV(tablePar);
            }}
            className="px-4 py-2 text-sm font-medium text-[#34656d] hover:bg-[#34656d]/5 rounded-lg transition-colors duration-200 flex items-center space-x-2 download-button"
          >
            <svg
              className="w-4 h-4"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            <span>Download Data</span>
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-100">
        <div className="flex space-x-1 px-4 chart-tabs">
          {TABS.map((tab) => (
            <button
              key={tab.label}
              onClick={() => setActiveTab(tab)}
              className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors duration-200 chart-tab ${
                activeTab.label === tab.label
                  ? "border-[#34656d] text-[#34656d]"
                  : "border-transparent text-gray-500 hover:text-[#34656d] hover:border-[#34656d]/30"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="px-6 gas-chart-container pt-4 bg-white h-[450px]">
        {activeTab.label === "Chart" && (
          <ReMixChart
            data={chartData.data}
            xDataKey={"xAxis"}
            secondXDataKey={chartPar?.secondXAxisLabel ? "secondXAxis" : undefined}
            legends={getNonZeroLegends()}
            unit={""}
            secondYAxisLabel={chartPar?.secondYAxisLabel ?? undefined}
            fontSize={14}
            yAxisLabel={chartPar?.yAxisLabel}
            yAxisWidth={50}
          
            // secondYAxisWidth={65}
            // yAxisWidth={1-0}
            showBrush={chartData.data.length > 96}
          />
        )}
        {activeTab.label === "Summary" && (
          <div className="flex flex-col h-full overflow-auto custom-scrollbar">
            <LegendSummaryTable {...{
                  data: chartData.data,
                  tableData: chartData.tableData,
                  keysLabels: chartData.keysLabels,
                  volumeKey: "value",
                  extraKeys: ["xAxis", ...(chartPar?.secondXAxisLabel ? ["secondXAxis"] : [])],
                  extraLabels: [chartPar?.xAxisLabel ?? "", ...(chartPar?.secondXAxisLabel ? [chartPar?.secondXAxisLabel ?? ""] : [])],
                  legends: getNonZeroLegends(),
                  unit: "mw",
                  showTotal: false,
              
                  // extraKeys:
                  //   chartPar.secondXAxisKey !== "" && chartPar.secondXAxisKey !== undefined
                  //     ? [chartPar.xAxisKey, chartPar.secondXAxisKey]
                  //     : [chartPar.xAxisKey],
                  // extraLabels: [],
              
            }} />
          </div>
        )}
        {activeTab.label === "Table" && (
          <div className="flex flex-col h-full overflow-auto custom-scrollbar">
            <ChartTable {...tablePar} />
          </div>
        )}
      </div>
    </div>
  );

  function getNonZeroLegends() {
    const legends = chartData.keys
      .map((key, index) => {
        const [category, unit, chart_type, yAxis_type] = key.split("__");
        return {
        dataKey: key + "_" + "value",
        name:(category.replace("_", " ")),
        unit: titleCase(unit.replace("_", " ")),
        type: chart_type == "line" ? ChartType.Line : chart_type == "bar" ? ChartType.Bar : undefined,
        yAxisId: yAxis_type == "right" ? "right" : undefined,
        stroke: ExchangeColors[index % ExchangeColors.length],

      }})

    return legends.filter((legend) => {
      return chartData.data.some((item) => item[legend.dataKey] !== 0);
    });
  }
};

export default AgentChart;
